import React from 'react';
import loadable from '@loadable/component';
import { WaypointLazyRender } from '../../../../components/WaypointLazyRender';

const CollectionsBucketContainer = loadable(() =>
    import('./CollectionsBucketContainer'),
);

export const LazyLoadedCollectionsBucket = ({ tabKey }) => {
    return (
        <WaypointLazyRender bottomOffset="-400px">
            <CollectionsBucketContainer tabKey={tabKey} />
        </WaypointLazyRender>
    );
};
